import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '../../../../Components/ComponentInput';
import T from '../../Locale';
import { UserToUpdate } from '../../SignupForm.constants';
const UserInput = ({ field, onChangeValue, error = false, userToUpdate }) => {
    const [value, setValue] = useState('');
    return (_jsxs("div", Object.assign({ className: 'w-full md:w-1/2 mb-5 md:pr-5' }, { children: [_jsx("p", Object.assign({ className: `mb-1 ${error ? 'input-error text-viva-red' : ''}` }, { children: error || T(`partner.signup.${field}`) })), _jsx(Input, { id: `${userToUpdate}_${field}`, error: error !== false, onChange: (newValue) => {
                    setValue(newValue);
                    onChangeValue(field, newValue, userToUpdate);
                }, value: value, required: true })] })));
};
UserInput.propTypes = {
    field: PropTypes.string.isRequired,
    onChangeValue: PropTypes.func.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    userToUpdate: PropTypes.oneOf(Object.values(UserToUpdate))
};
export default UserInput;
